
export class GC_Valid_T_String {

    protected min;
    protected max;
    protected space;
    protected exact;

    constructor(opt) {
        this.min        = opt && opt.min || false;
        this.max        = opt && opt.max || false;
        this.space      = opt && opt.space || false;
        this.exact      = (opt && undefined !== opt.exact) ? opt.exact : false;
    }

    public validate(variable) {
        let ok = true;
        let len = (variable + '').length;
        if (false !== this.min) {
            ok  = ok && len >= this.min;
        }
        if (false !== this.max) {
            ok  = ok && len <= this.max;
        }
        if (false !== this.space) {
            ok  = ok && this.checkSpace(variable);
        }
        if (false !== this.exact) {
            ok  = ok && this.exact === variable;
        }
        return ok;
    }

    protected checkSpace(variable) {
        variable = variable + '';
        let en_space = ' ';
        let ch_space = '　';
        let len = variable.length;
        let has = 0;

        if (len > 0) {
            let first = variable[0];
            let last = variable[len - 1];
            if (en_space === first || ch_space === first) {
                has = 1;
            }
            if (en_space === last || ch_space === last) {
                has = 1;
            }
        }

        return has === 0;
    }

}
